import React, { useContext } from "react";
import { Text } from "@mantine/core";
import { SegmentationBlocksContext } from "../../providers/SegmentationBlocksProvider";
import { ISegmentationBlock } from "../../@types/segmentationBlocks";
import ProgressIndicator from "../../../../themes/components/ProgressIndicator";
import NoSegmentationBlocks from "./NoSegmentationBlocks";
import SegmentationBlockCard from "./SegmentationBlockCard";

interface SegmentationBlocksTabProps {
  onCreateNew: () => void;
  onEditBlock?: (block: ISegmentationBlock) => void;
}

const SegmentationBlocksTab: React.FC<SegmentationBlocksTabProps> = ({
  onCreateNew,
  onEditBlock,
}) => {
  const context = useContext(SegmentationBlocksContext);

  if (!context) {
    return null;
  }

  if (context.isLoading) {
    return <ProgressIndicator />;
  }

  if (context.isError) {
    return (
      <div className="flex items-center justify-center h-64">
        <Text color="red">
          Error loading segmentation blocks. Please try again.
        </Text>
      </div>
    );
  }

  if (context.segmentationBlocks.length === 0) {
    return <NoSegmentationBlocks onCreateNew={onCreateNew} />;
  }

  return (
    <div className="flex flex-col gap-6">
      {context.activeBlocks.length > 0 && (
        <div className="bg-white rounded pt-6 pb-2">
          <h3 className="text-[18px] font-bold text-[#111827] mb-2">
            Active segmentation blocks
          </h3>
          <div>
            {context.activeBlocks.map((block) => (
              <SegmentationBlockCard
                key={block.id}
                block={block}
                type="active"
                onEdit={onEditBlock}
              />
            ))}
          </div>
        </div>
      )}

      {context.inactiveBlocks.length > 0 && (
        <div className="bg-white rounded pt-6 pb-2">
          <h3 className="text-[18px] font-bold text-[#111827] mb-2">
            Inactive segmentation blocks
          </h3>
          <div>
            {context.inactiveBlocks.map((block) => (
              <SegmentationBlockCard
                key={block.id}
                block={block}
                type="inactive"
                onEdit={onEditBlock}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SegmentationBlocksTab;
